import React, { useState } from 'react';
import { AiOutlinePrinter } from 'react-icons/ai';
import { MdOutlinePaid } from 'react-icons/md';
import { AiOutlineEdit } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

import { BasicSelector, MwModal, CardHeadeWithActions } from '../../ui';
import { useNavigate, useParams } from 'react-router-dom';
import NotHaveInPackage from '../../NotHaveInPackage';


const InvoiceNavbar = ({handlePrint,deleteHandler,isPaid,isReturned,fullReturned,countReturned,showpaymentModal,setShowPaymentModal,invId}) => {
    const [t] = useTranslation('global')
    const navigate = useNavigate();
    const params = useParams();
    const [showSendMailModal,setShowSendMailModal] = useState(false);
    const onSelectSendInvoiceToCustomer = (value) => {
       // console.log(value)
        setShowSendMailModal(true);
    }
    const actionItemClass = "h-10 px-2 py-1 flex items-center gap-2 bg-slate-100 whitespace-nowrap";
    const clickableItemClass = `${actionItemClass} hover:font-bold cursor-pointer`;

    const actionsList = (
      <ul className="flex gap-2 list-none">
        <li className={clickableItemClass} onClick={handlePrint}>
          <AiOutlinePrinter size={16} /> طباعة
        </li>
        <li
          className={clickableItemClass}
          onClick={() => {
            navigate(`/${params.tenant}/invoices/edit/${params.id}`);
          }}
        >
          <AiOutlineEdit size={16} /> تعديل
        </li>
        <li className={clickableItemClass} onClick={deleteHandler}>
          <AiOutlinePrinter size={16} /> حذف
        </li>
        {isPaid && !fullReturned && (
          <li
            className={clickableItemClass}
            onClick={() => {
              navigate(`/${params.tenant}/invoices-returns/${invId}`);
            }}
          >
            انشاء فاتورة مرتجعة
          </li>
        )}
        {!isPaid && (
          <li
            className={clickableItemClass}
            onClick={() => setShowPaymentModal(!showpaymentModal)}
          >
            <MdOutlinePaid size={16} /> {t('invoice.PayInvoice')}
          </li>
        )}
      </ul>
    );

    const statusBadges = (
      <div className="flex items-center justify-center gap-1 text-xs">
        <BasicSelector
          className={`rounded-xl text-slate-500`}
          label={`ارسال نسخة للعميل pdf`}
          onSelected={onSelectSendInvoiceToCustomer}
          listItem={[
            {
              label: 'بريد الكتروني',
              value: 'sendMail',
            },
            {
              label: ' رسالة نصية',
              value: 'sendSms',
            },
          ]}
        />
        {isPaid ? (
          <div className="text-green-300 px-3 py-1 border border-green-300 rounded-xl">
            {t('invoice.PAID')}
          </div>
        ) : (
          <div className="text-red-300 px-3 py-1 border border-red-300">
            {t('invoice.UNPAID')}
          </div>
        )}
        {isReturned && countReturned > 0 && (
          <div className="text-orange-300 px-3 py-1 border border-orange-300 rounded-xl">
            {fullReturned ? <span>فاتورة مرتجعة كليا</span> : <span>فاتورة مرتجعة جزئيا</span>}
            <span> [{countReturned}] </span>
          </div>
        )}
      </div>
    );
    return (
      <>
        <MwModal onShow={showSendMailModal} setOnShow={setShowSendMailModal}>
          <NotHaveInPackage />
        </MwModal>
        <CardHeadeWithActions title="الفاتورة" icon={<AiOutlinePrinter size={20} />}>
          <div className="flex items-center justify-between gap-4 w-full">
            <div>{actionsList}</div>
            <div>{statusBadges}</div>
          </div>
        </CardHeadeWithActions>
      </>
    );
}

export default InvoiceNavbar
